import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { ReactstrapInput } from "reactstrap-formik";
import * as Yup from "yup";
import { Row, Col, Button, Card, CardHeader, CardBody, CardTitle } from "reactstrap";
import { useParams, useHistory } from "react-router-dom";
import { useAuth0 } from "react-auth0-spa";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import BlockedPhoneNumberService from "core/api/BlockedPhoneNumberService";
import { cleanPhoneNumberWithoutCountryCode } from "components/Phone/PhoneFunctions";
import { paths } from "utils/PathService";

const getTodayStr = () => new Date().toISOString().split("T")[0];

const BlockedPhoneNumberSchema = Yup.object().shape({
  phoneNumber: Yup.string().required("Required")
    .transform((value) => cleanPhoneNumberWithoutCountryCode(value))
    .matches(/^\d{10}$/, "Must be a valid 10-digit phone number"),
  blockedFrom: Yup.date().required("Required"),
  blockedUntil: Yup.date()
    .required("Required")
    .test("after-from", "Blocked Until must be after Blocked From", function(value) {
      return value > this.parent.blockedFrom;
    }),
  reason: Yup.string(),
});

const Edit = () => {
  let { id } = useParams();
  const history = useHistory();
  const { user } = useAuth0();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isUpdate = id != null;

  const initialData = {
    id: null,
    phoneNumber: "",
    blockedFrom: getTodayStr(),
    blockedUntil: "",
    reason: "",
    blockedBy: "",
  };

  const [data, setData] = useState(initialData);

  useEffect(() => {
    async function fetchData() {
      const result = await BlockedPhoneNumberService.get(id);
      setData({
        ...result,
        blockedFrom: result.blockedFrom ? result.blockedFrom.split("T")[0] : "",
        blockedUntil: result.blockedUntil ? result.blockedUntil.split("T")[0] : "",
      });
      setLoading(false);
    }
    
    if 
      (id) fetchData();
    else 
        setLoading(false);
  }, [id]);

  const submitForm = async (values, { setSubmitting }) => {
    setError(null);
    const dataToSave = {
      ...values,
      phoneNumber: cleanPhoneNumberWithoutCountryCode(values.phoneNumber),
      blockedBy: user.email
    };
    const res = await BlockedPhoneNumberService.add(dataToSave);

    if (!res.success) {
      setError(res.responseMessages?.join(", ") || "An error occurred. Please try again.");
      setSubmitting(false);
      return;
    }

    const savedItem = res.model[0];
    if (!isUpdate) {
      history.replace(paths.blockedPhoneNumber.view(savedItem.id), { showBackButton: true });
    } else {
      history.goBack();
    }
    setSubmitting(false);
  };

  if (loading) return <>loading</>;

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Blocked Number</CardTitle>
              </CardHeader>
              <CardBody>
                <Formik
                  initialValues={data}
                  validationSchema={BlockedPhoneNumberSchema}
                  onSubmit={submitForm}>
                  {({ isSubmitting }) => (
                    <Form className="form-horizontal">
                      <Row>
                        <Col>
                          <Field
                            type="text"
                            name="phoneNumber"
                            label="Phone Number"
                            component={ReactstrapInput}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Field
                            type="date"
                            name="blockedFrom"
                            label="Blocked From"
                            component={ReactstrapInput}
                          />
                        </Col>
                        <Col>
                          <Field
                            type="date"
                            name="blockedUntil"
                            label="Blocked Until"
                            component={ReactstrapInput}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Field
                            type="textarea"
                            rows="3"
                            name="reason"
                            label="Reason"
                            component={ReactstrapInput}
                          />
                        </Col>
                      </Row>
                      {error && <div className="invalid-feedback" style={{ display: "block", fontSize: 14, marginTop: 30, marginBottom: 10 }}>{error}</div>}
                      <Row>
                        <Col>
                          <Button type="submit" color="primary" disabled={isSubmitting}>
                            {isUpdate ? "Update" : "Create"}
                          </Button>
                          <Button color="primary" onClick={() => history.goBack()}>
                            Cancel
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Edit;
